{
  "WALLBOARD": {
    "LOADING": "Telefonsorok betöltése...",
    "NO_QUEUES": "Nem találhatók telefonsorok.",
    "AGENTS": "Ügynökök",
    "NO_AGENTS": "Nincsenek online ügynökök ebben a sorban.",
    "NO_AGENTS_ONLINE": "Nincsenek online ügynökök.",
    "WAITING_CALLERS": "Várakozó hívók",
    "NO_CALLERS": "Nincsenek várakozó hívók.",
    "UNKNOWN_CALLER": "Ismeretlen hívó",
    "POSITION": "Pozíció",
    "STATUS": "Állapot",
    "TIME": "Idő",
    "AGENT": "Ügynök",
    "EXTENSION": "Mellék",
    "AVAILABLE": "Elérhető",
    "READY": "Kész ügynökök",
    "ON_CALL": "Hívásban lévő ügynökök",
    "QUEUE_CALL": "Sor hívás",
    "OTHER_CALL": "Egyéb hívás",
    "PAUSED": "Szünetelő ügynökök",
    "WAITING": "Várakozó hívások",
    "MISSED_CALLS": "Nem fogadott hívások",
    "HANDLED_CALLS": "Kezelt bejövő hívások",
    "OUTBOUND_CALLS": "Kezelt kimenő hívások",
    "AVAILABILITY": "Elérhetőség",
    "AVAILABILITY_TOOLTIP": "Az ügynökök által fogadott bejövő hívások százalékos aránya (felvett hívások)",
    "TOTAL": "összesen",
    "AGENTS_COUNT": "({onCall} hívásban / {total} összesen)",
    "NO_AVAILABLE": "(senki sincs online)",
    "WAITING_CALLERS_COUNT": "{count} várakozik",
    "CALLER": "Hívó",
    "NUMBER": "Szám",
    "WAIT_TIME": "Várakozási idő",
    "QUEUES": "Sorok",
    "ACTION": "Művelet",
    "PICKUP_CALL": "Felvétel",
    "PICKING_UP": "Felvétel...",
    "PICKUP_SUCCESS": "Hívás felvétele sikeresen kezdeményezve.",
    "PICKUP_ERROR": "Nem sikerült felvenni a hívást. Kérjük, próbálja újra.",
    "PICKUP_DISABLED_TOOLTIP": "Nem tud hívást felvenni, ha éppen hívásban van vagy offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Nincs hozzáférés"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Nincs hozzáférés"
    }
  }
}
